var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "class-details"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 13.125V0.875H11.375V13.125H2.625ZM1.75 0.583334C1.75 0.261167 2.01117 0 2.33333 0H11.6667C11.9888 0 12.25 0.261167 12.25 0.583333V13.4167C12.25 13.7388 11.9888 14 11.6667 14H2.33333C2.01117 14 1.75 13.7388 1.75 13.4167V0.583334ZM3.64583 3.35417C3.64583 3.11254 3.84171 2.91667 4.08333 2.91667H8.75C8.99162 2.91667 9.1875 3.11254 9.1875 3.35417C9.1875 3.59579 8.99162 3.79167 8.75 3.79167H4.08333C3.84171 3.79167 3.64583 3.59579 3.64583 3.35417ZM4.08333 4.95833C3.84171 4.95833 3.64583 5.15421 3.64583 5.39583C3.64583 5.63746 3.84171 5.83333 4.08333 5.83333H7C7.24162 5.83333 7.4375 5.63746 7.4375 5.39583C7.4375 5.15421 7.24162 4.95833 7 4.95833H4.08333ZM4.08333 7C3.84171 7 3.64583 7.19588 3.64583 7.4375C3.64583 7.67912 3.84171 7.875 4.08333 7.875H8.75C8.99162 7.875 9.1875 7.67912 9.1875 7.4375C9.1875 7.19588 8.99162 7 8.75 7H4.08333Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/iconNotes.05019009148f3f82eb2a4e14aeec68ea.svg";
export { ForwardRef as ReactComponent };